export default {

  /**
   * Muestra una notificación a través de Toastr
   *
   * @param {String} titulo
   * @param {String} mensaje
   * @param {String} tipo
   */
  showToastr(titulo, mensaje, tipo) {
    if (window.toastr !== undefined) {

      // Opciones de Toastr
      toastr.options = {
        timeOut: 7000,
        positionClass: "toast-bottom-right",
        closeButton: true,
        progressBar: false,
        newestOnTop: true
      };

      switch (tipo) {
        case 'success':
          toastr.success(mensaje, titulo);
          break;
        case 'warning':
          toastr.warning(mensaje, titulo);
          break;
        case 'error':
        case 'danger':
          toastr.error(mensaje, titulo);
          break;
        default:
          toastr.info(mensaje, titulo);
          break;
      }
    }
  },

  /**
   * Muestra un overlay/modal de Bootstrap
   *
   * @param {String} tipo Tipo de overlay
   * @param {Object} params Parámetros de configuración para el overlay/modal
   */
  showBootbox(tipo, params) {
    if (window.bootbox !== undefined) {

      let emptyCallback = function () {
      };

      let mensaje = params !== undefined && params.mensaje !== undefined
        ? params.mensaje : 'N/A';
      let callback = params !== undefined && params.callback !== undefined
        ? params.callback : emptyCallback;
      let options = params !== undefined && params.options !== undefined
        ? params.options : {};

      switch (tipo) {
        case 'dialog':
          bootbox.dialog(options);
          break;
        case 'prompt':
          bootbox.prompt(mensaje, callback);
          break;
        case 'confirm':
          bootbox.confirm(mensaje, callback);
          break;
        default:
          bootbox.alert(mensaje, callback);
          break;
      }
    }
  }
};
